import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';

/**
 * PC_MTc_04 getMyToDoData gets imported from api.js file
 */
import { getMyToDoData } from '../service/api';

import '../components/css/Dashboard-styles.css';
import { workDayURL } from '../constant';

const EmpToDoData = () => {

    /**
* PC_MTc_02
* The data , todoVal state variable is created for storing the response data
*/
    const [data, setData] = useState([]);


    /**
* PC_MTc_03
* Use Efffect method is called 
*/

    useEffect(() => {
        fetchApi();
    }, []);

    /**
* PC_MTc_06
* The fetchApi function in the useEffects gets invoked which inturn call the getMyTodoData() function with respective parameters
*/

    const fetchApi = async () => {
        const resp = await getMyToDoData();

        if (resp?.data?.length > 0) setData(resp.data);
    };

    const priority = (priority) => {
        if (priority.toLowerCase().includes('high')) return 'dashboard-todo-working-new';
        else if (priority.toLowerCase().includes('medium')) return 'dashboard-todo-notstart-new';
        else if (priority.toLowerCase().includes('low')) return 'dashboard-todo-complete-new';
    };


    /**
* PC_MTc_10
* The response data gets stored in the data variable and mapped to the respective divs
*/

    const empToDo = () => {
        try {
            return data.map((datum, i) => {
                if (i < 6) return (
                    <>
                        <div className="p-2 d-flex" style={{ cursor: 'pointer' }}>
                            {/* <span className={`${priority(datum.priority)}`}> </span> */}
                            <span className={`dashboard-todo-notstart-new`}> </span>
                            <div className={`dashboard-todo-card rounded-5 `}>
                                <h2 className="font-12 ms-2">{datum?.type}</h2>
                                <h3 className="font-12 lable-color2 mt-2 ms-2" title={datum.work_item}>{datum.work_item.length > 40 ? datum.work_item.substring(0, 40) + "..." : datum.work_item}</h3>
                                <h3 className="font-12 mt-2 ms-2 blue">{datum.status}</h3>
                            </div>
                        </div>
                    </>
                );
            });
        } catch (err) {

        }
    };

    return (
        <>
            <div className="d-flex justify-content-between dashboard-container-background">
                <h1 className="tt-bold font-15 pt-3 ps-3">My Todo</h1>
                {/* <a href={`https://workdaynp.avasoft.com/apiservice/hive/${encryptStorage.getItem("userId")}/myTODO`} className="semibold-text font-12 pe-3 text-decoration-none mt-3">
                 */}
                <a href={`${workDayURL}`} className="semibold-text font-12 pe-3 text-decoration-none mt-3">

                    View all
                    <span>
                        <img src="/Images/view all.png" className="dashboard-view-arrow-size ms-1" />
                    </span>
                </a>
            </div>

            {empToDo()}
        </>
    );
};

export default EmpToDoData;
